import type { AxiosInstance } from 'axios';
import { TOURI_REQUEST_HEADERS } from '@/config/constants/touri';

/**
 * Mark every axios request as AJAX with `X-Requested-With: XMLHttpRequest`.
 *
 * Laravel remembers the last plain GET as the session's "previous URL" unless
 * the request says it is AJAX. Inertia visits say so; bare axios calls did
 * not. So the background polls (`/messaging/unread-count`, the notifications
 * list) became the previous URL every few seconds, and any validation failure
 * that redirects back sent the user to raw JSON instead of the page they were
 * on. Setting the header once here keeps background requests out of it.
 */
export const markAxiosRequestsAsAjax = (instance: Pick<AxiosInstance, 'defaults'>): void => {
    instance.defaults.headers.common['X-Requested-With'] = TOURI_REQUEST_HEADERS.X_REQUESTED_WITH;
};
